import playerComp1 from "../img/player-comps/player-comp@1x.png";
import playerComp1x2 from "../img/player-comps/player-comp@2x.png";
import playerComp2 from "../img/player-comps/player-comp2@1x.png";
import playerComp2x2 from "../img/player-comps/player-comp2@2x.png";
import playerComp3 from "../img/player-comps/player-comp3@1x.png";
import playerComp3x2 from "../img/player-comps/player-comp3@2x.png";
import playerCompWide1 from "../img/player-comps/player-comp-wide@1x.png";
import playerCompWide1x2 from "../img/player-comps/player-comp-wide@2x.png";
import playerCompWide2 from "../img/player-comps/player-comp-wide2@1x.png";
import playerCompWide2x2 from "../img/player-comps/player-comp-wide2@2x.png";
import playerCompWide3 from "../img/player-comps/player-comp-wide3@1x.png";
import playerCompWide3x2 from "../img/player-comps/player-comp-wide3@2x.png";

export interface IPlayerCompProps {
  images: Record<string, string>;
}

let choice = -1;

export const getPlayerComp = () => {
  const playerImages = [
    {
      x1: playerComp1,
      x2: playerComp1x2,
      x1wide: playerCompWide1,
      x2wide: playerCompWide1x2,
    },
    {
      x1: playerComp2,
      x2: playerComp2x2,
      x1wide: playerCompWide2,
      x2wide: playerCompWide2x2,
    },
    {
      x1: playerComp3,
      x2: playerComp3x2,
      x1wide: playerCompWide3,
      x2wide: playerCompWide3x2,
    },
  ];

  if (choice < 0) {
    choice = Math.floor(Math.random() * playerImages.length);
  }
  return playerImages[choice];
};
